import BasedModal from "components/BaseModalComponents/BasedModal";
import { IProps } from "components/BaseModalComponents/BasedModal";
import { GreenButton } from "components/Buttons/buttonsStyles";
import React from "react";
import { Container, modalStyle } from "../settingsModalStyles";

const ExitEditSessionModal: React.FC<IProps> = ({ isOpen, onRequestClose }) => {
    return (
        <BasedModal
            style={modalStyle}
            isOpen={isOpen}
            onRequestClose={onRequestClose}
        >
            <Container>
                <p>
                    Ваша сессия редактирования тикера деактивировалась в
                    следствии 10 минутной отсутствии активности
                </p>
                <GreenButton onClick={onRequestClose}>ОК</GreenButton>
            </Container>
        </BasedModal>
    );
};

export default ExitEditSessionModal;
